import type { LogLevel } from './types'

const LEVEL_ORDER: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
}

export function getDefaultLevel(): LogLevel {
  if (process.env.LOG_LEVEL) {
    return process.env.LOG_LEVEL as LogLevel
  }

  switch (process.env.NODE_ENV) {
    case 'test':
      return 'warn'
    case 'development':
      return 'debug'
    default:
      return 'info'
  }
}

export function shouldLog(messageLevel: LogLevel, minLevel: LogLevel): boolean {
  return LEVEL_ORDER[messageLevel] >= LEVEL_ORDER[minLevel]
}
